import React from 'react'
import { Switch, Route, Link } from 'react-router-dom'

import HelpArticle from './HelpArticle'
import HelpHome from './HelpHome'
import "./help.scss"

const HelpHeader = () => {
  return (
    <header>
      <div className="header-top">
        <div className="container">
          <a href="/landing.html">
            <div className="brand-logo">
                <img
                  src={'https://s3.amazonaws.com/geopagos/images/bajio/landing/logo-r-violet.png'}
                  alt="Bajio Venta Express"
                  />
            </div>
          </a>
        </div>
      </div>
      <div className="header-bottom">
        <div className="container">
          <h1>Centro de ayuda on-line</h1>
        </div>
      </div>
    </header>
  )
}

const HelpFooter = () => {
  return (
    <footer>
      <div className="container">
        <div className="footer-content">
          <span>Venta Express BanBaj&iacute;o es un producto de Banco del Baj&iacute;o, S.A.,
              Instituci&oacute;n de Banca M&uacute;ltiple. Derechos Reservados © 2017, M&eacute;xico.</span>
        </div>
      </div>
    </footer>
  )
}

class Help extends React.Component {

  render() {
    return (
      <div className="help-main">
        <HelpHeader/>
        <Switch>
          <Route exact path="/help" component={HelpHome}/>
          <Route path="/help/:article" component={HelpArticle}/>
        </Switch>
        <HelpFooter/>
      </div>
    )
  }
}

export default Help